import React from "react";

import { UseOfName } from "../../interfaces/enum";
import dateUtil from "../../lib/dateUtil";
import { getFullName } from "../../lib/nameUtil";
import styles from "./PersonalDetails.module.scss";

interface InsuredData {
  dateOfBirth: string;
  street: string;
  houseNumber: number | null;
  houseNumberAddition?: string;
  city: string;
  postcode: string;
  emailAddress: string;
  mobileNumber: string;
  salutation: string;
  initials: string;
  firstName: string;
  lastName: string;
  location: string;
  inserts: string;
  hasPartner: boolean;
  partnerInserts: string;
  partnerLastName: string;
  useOfName: UseOfName;
  telephoneNumber?: string;
}

interface Props {
  details: Partial<InsuredData>;
}

export const PersonalDetails = ({ details }: Props) => (
  <div className={styles.personalDetails__wrapper}>
    <div className={styles.personalDetails__container}>
      <div>
        <i className={`${styles.personalDetails__icon} icon-persoon`} />
      </div>
      <div className={styles.personalDetails__content}>
        <strong>{`${getFullName(details)}${
          details.dateOfBirth ? ` - ${dateUtil.dutchDateToDateWithWrittenMonth(details.dateOfBirth)}` : ""
        }`}</strong>
      </div>
    </div>
    <div className={styles.personalDetails__container}>
      <div />
      <div className={styles.personalDetails__content}>
        {details.street} {details.houseNumber}
        {details.houseNumberAddition ? ` ${details.houseNumberAddition}` : ""}
        {details.location ? `, ${details.location}` : ""}
        <br />
        {details.postcode ? `${details.postcode}, ` : ""}
        {details.city}
      </div>
    </div>

    <div className={styles.personalDetails__container}>
      <div />
      <div className={styles.personalDetails__content}>
        <span>{details.emailAddress}</span>
        <span>{details.mobileNumber}</span>
        <span>{details.telephoneNumber}</span>
      </div>
    </div>
  </div>
);
